<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ $route.meta.title }}
          <el-button class="title_btn" type="primary" @click="moveCreate()"
          >등록</el-button
          >
        </div>
        <div class="list-content">
          <push-list-component :pushType="'push'"></push-list-component>
        </div>
      </div>
      <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
    </div>
  </div>
</template>

<script>

import PushListComponent from "@/components/push/PushListComponent";

export default {
  name: "Push",
  mixins: [],
  components: {PushListComponent},
  provide() {
    return {};
  },
  props: {},
  data() {
    return {};
  },
  created() {
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  computed: {},
  methods: {
    moveCreate() {
      this.$router.replace(this.$route.path);
      this.$router.push(`push/create`);
    },
  },
  watch: {},
};
</script>
